export default __webpack_public_path__ + "static/media/triathlon.dd772808.jpg";